<!--
  Navbar.vue
    Navigation bar Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div> <!-- @Memo Vue Componentはひとつの要素のみである必要があるため<div>で囲っておく -->
  <v-toolbar dark color="primary" app class="hm-toolbar hm-iphonex-notch">
    <v-toolbar-side-icon @click="onMenuIconClicked"></v-toolbar-side-icon>
    <v-spacer />

    <!-- ロゴ -->
    <span class="hm-logo-mobile">
      <img class="navbar-title-img" src="../assets/heresme-icon-32.png" />
    </span>
    <span class="hm-logo-monitor">
      <img class="navbar-title-img" src="../assets/heresme-icon-48.png" />
    </span>
    <span class="navbar-title">Here's Me</span>
    <v-spacer />

    <!-- 日時 -->
    <span class="navbar-date">{{ nowDate }}</span>

  </v-toolbar>

  <!-- menu -->
  <v-navigation-drawer
    temporary
    v-model="mDrawer"
    app
    clipped
  >
  <div class="hm-iphonex-notch">
    <v-list>
      <v-list-tile-content>
        <v-list-tile-title class="menu-title hm-bg-primary">
          <v-layout wrap align-center text-xs-center>
            <!-- debug用のGPSアイコン -->
            <!--
            <span :class="isGnssReady">
              <v-icon color="white" class="hm-navbar-gnss">location_on</v-icon>
            </span>
            -->
            <v-flex xs3>
              <div :class="{'hm-hide': !isAvatarAvailable}">
                <v-avatar>
                  <img :src="this.mAvatarImg">
                </v-avatar>
              </div>
              <div :class="{'hm-hide': isAvatarAvailable}">
                <v-avatar color="grey lighten-1">
                  <v-icon color="grey lighten-4">person</v-icon>
                </v-avatar>
              </div>
            </v-flex>
            <v-flex xs5>
              {{ mLoginUserBaseInfo.name }}
            </v-flex>
            <v-flex xs4>
              <div class="hm-display-monitor" @click="onWhClicked">
                <place-icon :pStatusId="mLoginUserWhereabouts.state" :pViewMode="'menulist'" />
              </div>
            </v-flex>
          </v-layout>
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list>

    <v-divider />

    <v-list>
      <!-- ユーザ設定 start -->
      <v-list-group
        prepend-icon="settings"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title class="hm-clr-primary">ユーザ設定</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="menu in mUserSubMenuList"
          :key="menu.id"
          @click="onMenuClicked(menu.strkey)"
          class="hm-nb-sublist"
        >
          <v-list-tile-action>
            <v-icon>{{ menu.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="hm-clr-primary">{{ menu.name }}</v-list-tile-title>
        </v-list-tile>

      </v-list-group>
      <!-- ユーザ設定 end -->

      <!-- ブラウザメニュー start -->
      <!-- 各メニュー項目でhm-display-monitorを指定しても反映されないので、groupレベルで指定する -->
      <v-list-group
        prepend-icon="tv"
        class="hm-display-monitor"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title class="hm-clr-primary">ブラウザメニュー</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="menu in mBrowserSubMenuList"
          :key="menu.id"
          @click="onMenuClicked(menu.strkey)"
          class="hm-nb-sublist"
        >
          <v-list-tile-action>
            <v-icon>{{ menu.icon }}</v-icon>
            <!--<v-icon
              v-bind:class="{'hm-icon-rotate': (menu.type === 'columnSwitch')}"
            >
              {{ menu.icon }}
            </v-icon>-->
          </v-list-tile-action>
          <v-list-tile-title
            v-bind:class="{
              'hm-clr-primary': (menu.type !== 'select') || ((menu.type === 'select') && mScreenView),
              'hm-menu-disabled': (menu.type === 'select') && !mScreenView,
              'hm-menu-sub': menu.type === 'select'
            }"
          >
            {{ menu.name }}
          </v-list-tile-title>
          <v-list-tile-action>
            <v-switch
              v-on:click.stop="onMenuClicked()"
              v-if="menu.type === 'screenSwitch'"
              v-model="mScreenView"
              color="primary"
            ></v-switch>
            <!-- ～ver2.5
            <v-switch
              v-on:click.stop="onMenuClicked()"
              v-if="menu.type === 'columnSwitch'"
              v-model="mScreenColumn"
              :disabled="!mScreenView"
              :readonly="!mScreenView"
              color="primary"
            ></v-switch>
            -->
            <v-select
              v-if="menu.strkey === 'screenlayout'"
              v-model="mScreenLayout"
              :items="menu.list"
              item-text="name"
              item-value="val"
              :disabled="!mScreenView"
              :readonly="!mScreenView"
              outlined
              class="hm-menu-select"
            ></v-select>
            <v-select
              v-if="menu.strkey === 'dispitem'"
              v-model="mDispItem"
              :items="menu.list"
              item-text="name"
              item-value="val"
              :disabled="isDisabledDispItem"
              :readonly="!mScreenView"
              outlined
              class="hm-menu-select"
            ></v-select>
            <v-select
              v-if="menu.strkey === 'interval'"
              v-model="mCarouselInterval"
              :items="menu.list"
              item-text="name"
              item-value="val"
              :disabled="!mScreenView"
              :readonly="!mScreenView"
              outlined
              class="hm-menu-select"
            ></v-select>
          </v-list-tile-action>
        </v-list-tile>
      </v-list-group>
      <!-- ブラウザメニュー end -->

      <!-- 勤怠管理 start -->
      <v-list-group
        prepend-icon="list_alt"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title class="hm-clr-primary">勤怠管理</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="menu in filteredAttendanceSubMenuList"
          :key="menu.id"
          @click="onMenuClicked(menu.strkey)"
          class="hm-nb-sublist"
        >
          <v-list-tile-action>
            <v-icon>{{ menu.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
           v-if="menu.explain!==''" class="hm-clr-primary"
          >
            <div class="hm-display-mobile">
              <p slot="activator">{{ menu.name }}</p>
            </div>
            <div class="hm-display-monitor">
              <v-tooltip bottom>
                <p slot="activator">{{ menu.name }}</p>
                <span>{{ menu.explain }}</span>
              </v-tooltip>
            </div>
          </v-list-tile-title>
          <v-list-tile-title
           v-else class="hm-clr-primary"
          >
              {{ menu.name }}
          </v-list-tile-title>
          <v-list-tile-action>
            <v-switch
              v-on:click.stop="onMenuClicked()"
              v-if="menu.type === 'teleworkSwitch'"
              v-model="mTelework"
              color="primary"
            ></v-switch>
            <v-switch
              v-on:click.stop="onMenuClicked()"
              v-if="menu.type === 'linkedTwswitch'"
              v-model="mLinkedTw"
              color="primary"
            ></v-switch>
          </v-list-tile-action>
        </v-list-tile>

      </v-list-group>
      <!-- 勤怠管理 end -->

      <!-- 位置情報 start -->
      <v-list-group
        prepend-icon="location_on"
        :class="{'hm-hide': !isDispGeolocationMenu}"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title class="hm-clr-primary">位置情報</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="menu in filteredGeolocationSubMenuList"
          :key="menu.id"
          @click="onMenuClicked(menu.strkey)"
          class="hm-nb-sublist"
        >
          <v-list-tile-action>
            <v-icon>{{ menu.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="hm-clr-primary">{{ menu.name }}</v-list-tile-title>
        </v-list-tile>

      </v-list-group>
      <!-- 位置情報 end -->

      <!-- 各種共通メニュー start -->
      <v-list-tile
        v-for="menu in mMenuList"
        :key="menu.id"
        @click="onMenuClicked(menu.strkey, menu.url)"
        :class="{'hm-hide': (menu.id === '002' && $vuetify.breakpoint.xsOnly)}"
      >
        <v-list-tile-action>
          <v-icon>{{ menu.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="hm-clr-primary" v-if="menu.url === ''">
            {{ menu.name }}
          </v-list-tile-title>
          <v-list-tile-title class="hm-clr-primary" v-else>
            <div class="hm-display-mobile">
            {{ menu.name }}
            </div>
            <div class="hm-display-monitor">
            <a :href="menu.url" target="_blank">
            {{ menu.name }}
            </a>
            </div>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <!-- 各種共通メニュー end -->

    </v-list>
  </div>
  </v-navigation-drawer>

  <!-- refでChild Componentにイベント通知する -->
  <map-location ref="mapLocation" />
  <map-location-view ref="mapLocationView" />
  <telework-list ref="teleworkList" />
  <passwd-change ref="passwdChange" />
  <profile ref="profile" />
  <guidepage ref="guidepage" />
  <faqpage ref="faqpage" />
  <aboutpage ref="aboutpage" />
  <error-dialog ref="errorDialog">
    <div slot="msg">Plug-inの起動準備ができていません. 暫くしてからタップしてください</div>
  </error-dialog>

  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
//import moment from 'moment'
import { mapState } from 'vuex'
import { ROUTE_PATH } from '@/router/routes'
import {
  MenuList,
  UserSubMenuList,
  BrowserSubMenuList,
  AttendanceSubMenuList,
  GeolocationSubMenuList,
  getNowDatetimeMoment,
  formatDateMoment,
  isNullorUndefined,
  //LS_SCREEN_VIEW,
  //LS_SCREEN_COLUMN,
  //LS_DISP_ITEM,
  //LS_CAROUSEL_INTERVAL
} from '@/common'
import MapLocationDialog from '@/components/dialogs/MapLocationDialog'
import MapLocationViewDialog from '@/components/dialogs/MapLocationViewDialog'
import TeleworkListDialog from '@/components/dialogs/TeleworkListDialog'
import PasswdChangeDialog from '@/components/dialogs/PasswdChangeDialog'
import ProfileDialog from '@/components/dialogs/ProfileDialog'
import GuideDialog from '@/components/dialogs/GuidePage'
import FaqDialog from '@/components/dialogs/FaqPage'
import AboutDialog from '@/components/dialogs/AboutAppPage'
import SelectedWhereaboutsInfoDialog from '@/components/dialogs/SelectedWhereaboutsInfoDialog'
import PlaceIcon from '@/components/parts/PlaceIcon'
import ErrorDialog from '@/components/dialogs/ErrorInfoDialog'

export default {
  name: 'Navbar',
  data: () => ({
    mDrawer: false,
    mMenuList: MenuList,
    mUserSubMenuList: UserSubMenuList,
    mBrowserSubMenuList: BrowserSubMenuList,
    mAttendanceSubMenuList: AttendanceSubMenuList,
    mGeolocationSubMenuList: GeolocationSubMenuList,
    nowDate: '',
    nowTime: '',
    mAvatarImg: null,
    mLogo: '../assets/heresme-icon-72.png',
    mAvatarExists: false,
    // localStorageは文字列でgetされるので文字列で比較して、Booleanに変換している.
    mScreenView: false,
    //mScreenColumn: (localStorage.getItem(LS_SCREEN_COLUMN) === 'true'),   // ～ver2.5
    mScreenLayout: null,
    mDispItem: null,
    mCarouselInterval: null,
    mAttendance: false,
    mTelework: false,
    mLinkedTw: false,
  }),
  components: {
    //'user-settings': UserSettingsDialog,
    'map-location': MapLocationDialog,
    'map-location-view': MapLocationViewDialog,
    'telework-list': TeleworkListDialog,
    'passwd-change': PasswdChangeDialog,
    'profile': ProfileDialog,
    'guidepage': GuideDialog,
    'faqpage': FaqDialog,
    'aboutpage': AboutDialog,
    'selected-whereabouts-dialog': SelectedWhereaboutsInfoDialog,
    'place-icon': PlaceIcon,
    'error-dialog': ErrorDialog,
  },
  mounted: function () {
    //this.$log.debug('# Navbar')
    //this.$log.debug('★[Navbar]' + JSON.stringify(this.mLoginUserBaseInfo))
    this.mAvatarImg = this.mLoginUserBaseInfo.avatar + '?' + Date.now()
    this.nowDateTime()
    this.$store.dispatch('initBrowserMenuSetting', true)
    this.mScreenView = (this.mSystemSettings.sScreenLayout[0] !== '0')
    this.mScreenLayout = this.mSystemSettings.sScreenLayout[1]
    this.mDispItem = this.mSystemSettings.sDispItem
    this.mCarouselInterval = this.mSystemSettings.sCarouselInterval
    this.mAttendance = (this.mLoginUserBaseInfo.attendance_flg === 1)
    this.mTelework = (this.mLoginUserBaseInfo.telework_flg === 1)
    this.mLinkedTw = (this.mLoginUserBaseInfo.linked_wh_flg === 1)
  },
  destroyed: function () {
    //this.$log.debug('# Navbar')
  },
  watch: {
    mScreenView: function (current, previous) {
      //this.$log.debug('★mScreenView (' + previous + ')→(' + current + ') 更新値(' + ((this.mScreenView === true ? '1' : '0') + this.mScreenLayout) + ')')
      this.$emit('showLoading')
      // ～ver2.5 this.$store.dispatch('changeScreenView', current)
      if (this.mScreenLayout === null) {
        // 初回表示時(mScreenLayoutがnull)は更新しない
        return
      }
      this.$store.dispatch(
        'changeScreenLayout',
        (this.mScreenView === true ? '1' : '0') + this.mScreenLayout
      )
    },
    /* ～ver2.5
    mScreenColumn: function (current, previous) {
      this.$emit('showLoading')
      this.$store.dispatch('changeScreenColumn', current)
    },*/
    mScreenLayout: function (current, previous) {
      //this.$log.debug('★mScreenLayout (' + previous + ')→(' + current + ') 更新値(' + ((this.mScreenView === true ? '1' : '0') + this.mScreenLayout) + ')')
      this.$emit('showLoading')
      if (previous === null) {
        // 初回表示時は更新しない
        return
      }
      this.$store.dispatch(
        'changeScreenLayout',
        (this.mScreenView === true ? '1' : '0') + this.mScreenLayout
      )
    },
    mDispItem: function (current, previous) {
      //this.$log.debug('★mDispItem (' + previous + ')→(' + current + ')')
      this.$emit('showLoading')
      if (previous === null) {
        // 初回表示時は更新しない
        return
      }
      this.$store.dispatch(
        'changeDispItem',
        this.mDispItem
      )
    },
    mCarouselInterval: function (current, previous) {
      //this.$log.debug('★mCarouselInterval (' + previous + ')→(' + current + ')')
      this.$emit('showLoading')
      if (previous === null) {
        // 初回表示時は更新しない
        return
      }
      this.$store.dispatch(
        'changeCarouselInterval',
        this.mCarouselInterval
      )
      setTimeout(() => {
        this.$emit('hideLoading')
      }, 500)
    },
    mTelework: function (current, previous) {
      this.$store.dispatch(
        'aChangeTeleworkFlg',
        {
          user_id: this.mLoginUserBaseInfo.user_id,
          telework_flg: (this.mTelework === true ? 1 : 0)
        }
      )
    },
    mLinkedTw: function (current, previous) {
      this.$store.dispatch(
        'aChangeLinkedTelework',
        {
          user_id: this.mLoginUserBaseInfo.user_id,
          linked_wh: (this.mLinkedTw === true ? 1 : 0)
        }
      )
    },
    'mLoginUserBaseInfo.avatar': function (current, previous) {
      this.mAvatarImg = current
    },
  },
  computed: {
    ...mapState({
      mIsMobile: state => state.sIsMobile,
      mLoginUserBaseInfo: state => state.loginUser.sUserBaseInfo,
      mLoginUserWhereabouts: state => state.loginUser.sUserInfo,
      mSystemSettings: state => state.systemSettings,
      //mScreenView: state => (state.systemSettings.sScreenLayout[0] !== '0'),
      //mScreenLayout: state => state.systemSettings.sScreenLayout[1],
      //mDispItem: state => state.systemSettings.sDispItem,
      //mCarouselInterval: state => state.systemSettings.sCaouselInterval,
    }),
    // -------------------------------------------------------------------------
    // ログインユーザの設定状況に応じて表示する勤怠管理メニューを決定する
    filteredAttendanceSubMenuList: function () {
      let retSubmenuList = this.mAttendanceSubMenuList

      // 勤怠管理フラグチェック
      if (!this.mAttendance) {
        // 「テレワーク勤務」のみ表示
        retSubmenuList = retSubmenuList.filter(menu => (menu.type === 'teleworkSwitch'))
      }
      return retSubmenuList
    },
    // -------------------------------------------------------------------------
    // ログインユーザの設定状況に応じて表示する位置情報メニューを決定する
    filteredGeolocationSubMenuList: function () {
      let retSubmenuList = this.mGeolocationSubMenuList

      // 端末チェック
      if (this.mIsMobile) {
        retSubmenuList = retSubmenuList.filter(menu => !(menu.type === 'monitor'))
      }

      // 管理者チェック
      let isManager = (this.mLoginUserBaseInfo.admin_flg === 1) || (this.mLoginUserBaseInfo.admin_flg === '1')
      if (!isManager) {
        retSubmenuList = retSubmenuList.filter(menu => !(menu.type === 'admin'))
      }
      return retSubmenuList
    },
    // -------------------------------------------------------------------------
    isDisabledDispItem: function () {
      // スクリーン表示OFF または レイアウト１列選択時は、表示項目は非活性
      //this.$log.debug('★★[Navbar] screenView(' + this.mScreenView + ') layout(' + this.mScreenLayout + ') dispItem(' + this.mDispItem + ') interval(' + this.mCarouselInterval + ')')
      return (!this.mScreenView || (this.mScreenView && (this.mScreenLayout === '0')))
    },
    // -------------------------------------------------------------------------
    isDispGeolocationMenu: function () {
      let isManager = (this.mLoginUserBaseInfo.admin_flg === 1) || (this.mLoginUserBaseInfo.admin_flg === '1')
      if (isManager || !this.mIsMobile) {
        // 管理者かWeb表示の場合はメニューを表示する
        //this.$log.debug('★位置情報メニュー 表示する  isMagager(' + isManager + ') isMobile(' + this.mIsMobile + ')')
        return true
      }
      else {
        //this.$log.debug('★位置情報メニュー 表示しない  isMagager(' + isManager + ') isMobile(' + this.mIsMobile + ')')
        return false
      }
    },
    // -------------------------------------------------------------------------
    /*isTeleworkUser: function () {
      // Navbarはログイン後に表示されるので、LoginUser情報は取得されているはず
      console.assert(!isNullorUndefined(this.mLoginUserBaseInfo))
      return (this.mLoginUserBaseInfo.telework_flg === 1) || (this.mLoginUserBaseInfo.telework_flg === '1')
    },*/
    // -------------------------------------------------------------------------
    /*isManager: function () {
      // Navbarはログイン後に表示されるので、LoginUser情報は取得されているはず
      console.assert(!isNullorUndefined(this.mLoginUserBaseInfo))
      return (this.mLoginUserBaseInfo.admin_flg === 1) || (this.mLoginUserBaseInfo.admin_flg === '1')
    },*/
    // -------------------------------------------------------------------------
    imgSrc: function () {
      // Navbarはログイン後に表示されるので、LoginUser情報は取得されているはず
      console.assert(!isNullorUndefined(this.mLoginUserBaseInfo))
      return this._checkAvatarExists(this.mLoginUserBaseInfo)
    },
    // -------------------------------------------------------------------------
    isAvatarAvailable: function () {
      return (!isNullorUndefined(this.mLoginUserBaseInfo.avatar) && (this.mLoginUserBaseInfo.avatar !== ''))
    },
    /*
    // -------------------------------------------------------------------------
    isGnssReady: function () {
      return { 'navbar-gnss': !(this.gnssReady) }
    },
   */
  },
  methods: {
    // -------------------------------------------------------------------------
    onMenuIconClicked: function () {
      this.mDrawer = !this.mDrawer
      this.updateMenuTitleInfo()
    },
    // -------------------------------------------------------------------------
    updateMenuTitleInfo: async function () {
      // Avatar画像更新
      const avatar_res = await this.$store.dispatch('aGetLoginUserAvatarInfo')

      if (avatar_res.error || avatar_res.body.error) {
        this.mAvatarImg = ''
      }
      else {
        this.mAvatarImg = (isNullorUndefined(this.mLoginUserBaseInfo.avatar) || (this.mLoginUserBaseInfo.avatar === ''))
          ? '' : this.mLoginUserBaseInfo.avatar + '?' + Date.now()
      }

      // 行動予定更新
      // 失敗しても特に何もしない
      this.$store.dispatch('aGetLoginUserWhereaboutsInfo')
    },
    // -------------------------------------------------------------------------
    onMenuClicked: function (menu, url) {
      //this.$log.debug('★[onMenuClicked] ' + menu + '(' + moment().format('YYYY-MM-DD HH:mm:ss:SSS') + ')')
      switch (menu) {
        case 'passwd':
          this.$refs.passwdChange.$emit('changePasswd')
          this.mDrawer = false
          break
        case 'profile':
          this.$refs.profile.$emit('showProfile')
          this.mDrawer = false
          break
        case 'mylocation':
          this.$refs.mapLocation.$emit('showMapLocation')
          this.mDrawer = false
          break
        case 'screenview':
          this.mScreenView = !this.mScreenView
          break
        /*case 'columns':
          if (this.mScreenView) {
            this.mScreenColumn = !this.mScreenColumn
          }
          break*/
        case 'mappos':
          this.$refs.mapLocationView.$emit('onClickMapLocationList')
          this.mDrawer = false
          break
        case 'telework':
          // telework switch change
          this.mTelework = !this.mTelework
          break
        case 'linkedtw':
          // linked telework switch change
          this.mLinkedTw = !this.mLinkedTw
          break
        case 'teleworklist':
          this.$refs.teleworkList.$emit('showTeleworkList')
          this.mDrawer = false
          break
        case 'guide':
          this.$refs.guidepage.$emit('show')
          this.mDrawer = false
          break
        case 'faq':
          this.$refs.faqpage.$emit('show')
          this.mDrawer = false
          break
        case 'abouts':
          this.$refs.aboutpage.$emit('show')
          this.mDrawer = false
          break
        case 'logout':
          this.$store.dispatch('initBrowserMenuSetting', false)
          this.$store.dispatch('aChangeLoginStatus', false)
          this.$router.push(ROUTE_PATH.ROUTE_LOGIN)
          break
        default:
          break
      }
      //this.$log.debug(menu)
    },
    // -------------------------------------------------------------------------
    onWhClicked: function (menu) {
      this.$store.dispatch('aChangeWASelectedOnMenu', true)
    },
    // -------------------------------------------------------------------------
    isSwitchType: function (type) {
      if (type === 'switch') {
        return true
      }
      return false
    },
    // -------------------------------------------------------------------------
    nowDateTime: function () {
      // setIntervalの中に定義した処理は、指定の時間経過してから最初の１回目が
      // 実行されるため、setIntervalの前に１度処理を実行する。
      this.getNowDateTime()
      setInterval(() => {
        this.getNowDateTime()
      }, 10000)
    },
    getNowDateTime: function () {
      this.nowDate = formatDateMoment(getNowDatetimeMoment(), 'YYYY.MM.DD')
      this.nowTime = formatDateMoment(getNowDatetimeMoment(), 'HH:mm:ss')
    },
    // -------------------------------------------------------------------------
    _checkAvatarExists: function (userinfo) {
      let avatar = null
      if (isNullorUndefined(userinfo.avatar) || (userinfo.avatar === '')) {
        this.mAvatarExists = false
      }
      else {
        this.mAvatarExists = true
        avatar = userinfo.avatar + '?' + Date.now()
      }
      //this.$log.debug(avatar)
      return avatar
    },
    /*
    // -------------------------------------------------------------------------
    onClickScreen: function () {
    },
    */
    dispGroupList: function () {
      this.$router.push(ROUTE_PATH.ROUTE_WHEREABOUTS_LIST)
      this.$store.dispatch('aChangeCurrentPage', 'group')
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.navbar-title-img,
.navbar-title {
  vertical-align: middle;
}
.navbar-title {
  font-size: calc(1.25em + 0.75vw);
}
.navbar-setting-title {
  padding-left: 10px;
  font-size: calc(1.25em + 0.4vw);
}
@media screen and (min-width: 601px) {
  /* 幅601px～ */
  .navbar-title {
    font-size: calc(1.25em + 0.75vw);
  }
  .navbar-setting-title {
    padding-left: 20px;
    font-size: calc(1.25em + 0.5vw);
  }
  .navbar-date {
    font-size: calc(1.25em + 0.75vw);
  }
  .navbar-time {
    font-size: calc(1.25em + 0.75vw);
    display: block;
  }
}

.menu-title {
  height: 80px;
  line-height: 80px;
  font-size: 1.2em;
  color: #ffffff;
}

.hm-logo-mobile {
  display: block;
}
.hm-logo-monitor {
  display: none;
}
.navbar-title-img {
  padding-right: 5px;
}
@media screen and (min-width: 601px) {
  /* 幅601px～ */
  .hm-logo-mobile {
    display: none;
  }
  .hm-logo-monitor {
    display: block;
  }
  .navbar-title-img {
    padding-left: 20px;
    padding-right: 10px;
  }
}

.hm-nb-avatar {
  margin-right: 30px;
}
.hm-nb-sublist {
  margin-left: 20px;
}
.hm-icon-rotate {
  transform: rotate( 90deg );
}
.hm-menu-disabled {
  color: #c9caca;
}
.hm-menu-sub {
  width: 60%;
}
.hm-menu-sub,
.hm-menu-select {
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue